import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import FileLogsDialog from "./FileLogsDialog/FileLogsDialog";

const FileLogs = () => {
	const [logs, setLogs] = useState([]);
	const [loading, setLoading] = useState(false);
	const [pageSize, setPageSize] = useState(10);
	const [page, setPage] = useState(0);
	const [rowCount, setRowCount] = useState(0);

	const [selectedLog, setSelectedLog] = useState(null);
	const [details, setDetails] = useState([]);
	const [detailsLoading, setDetailsLoading] = useState(false);

	// Fetch paginated logs
	useEffect(() => {
		const fetchLogs = async () => {
			setLoading(true);
			try {
				const res = await axios.get("/api/shipping_partner_reco/get_file_logs", {
					params: { page, pageSize },
				});
				setLogs(res.data.logs);
				setRowCount(res.data.total);
			} catch (err) {
				console.error("Error fetching logs:", err);
			} finally {
				setLoading(false);
			}
		};
		fetchLogs();
	}, [page, pageSize]);

	// Handle row click
	const handleRowClick = async (params) => {
		setSelectedLog(params.row);
		setDetailsLoading(true);
		try {
			const res = await axios.get(`/api/shipping_partner_reco/get_file_logs/${params.row.id}/details`);
			setDetails(res.data.details);
		} catch (err) {
			console.error("Error fetching details:", err);
		} finally {
			setDetailsLoading(false);
		}
	};

	const handleCloseDialog = () => {
		setSelectedLog(null);
		setDetails([]);
	};

	const columns = [
		{ field: "id", headerName: "ID", width: 90 },
		{ field: "partner", headerName: "Partner", width: 150 },
		{ field: "month", headerName: "Month", width: 100 },
		{ field: "year", headerName: "Year", width: 100 },
		{ field: "created_by", headerName: "Created By", width: 120 },
		{ field: "effective_date", headerName: "Effective Date", width: 180 },
		{ field: "remarks", headerName: "Remarks", width: 200 },
	];

	return (
		<div style={{ height: 600, width: "100%" }}>
			<DataGrid
				rows={logs}
				columns={columns}
				pagination
				paginationMode="server"
				rowCount={rowCount}
				paginationModel={{ page, pageSize }}
				onPaginationModelChange={(model) => {
					setPage(model.page);
					setPageSize(model.pageSize);
				}}
				pageSizeOptions={[10, 20, 50]}
				loading={loading}
				components={{ Toolbar: GridToolbar }}
				onRowClick={handleRowClick}
			/>

			<FileLogsDialog
				open={!!selectedLog}
				onClose={handleCloseDialog}
				logId={selectedLog?.id}
				details={details}
				loading={detailsLoading}
			/>
		</div>
	);
};

export default FileLogs;
